export default {
  path: "/user/comisiones",
  component: () =>
    import("@/views/user/comisiones/ComisionesLayout.vue"),
  meta: {
    requiresAuth: true,
    requiresCurso: true,
    requiresDirectiva: true,
  },
  children: [
    {
      path: "",
      name: "comisiones-list",
      component: () =>
        import("@/views/user/comisiones/ComisionesListView.vue"),
    },
    {
      path: "nueva",
      name: "comisiones-nueva",
      component: () =>
        import("@/views/user/comisiones/ComisionEditorView.vue"),
    },
    {
      path: ":commissionId",
      name: "comisiones-detalle",
      component: () =>
        import("@/views/user/comisiones/ComisionDetalleView.vue"),
      props: true,
    },
  ],
};
